import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindMethods } from '../index';
import * as validations from './validation';

export { default as TextField } from './TextField';
export { default as SelectField } from './SelectField';
export { default as RadioField } from './RadioField';
export { default as OnOffField } from './OnOffField';
export { default as FilteredListField } from './FilteredListField';
export { default as TagField } from './TagField';
export { default as FormattedField } from './FormattedField';
export { default as TimeField } from './TimeField';
export { default as ArrayField } from './ArrayField';
export { default as NonEmptyArrayField } from './NonEmptyArrayField';
export { default as CheckField } from './CheckField';
export { default as TextareaField } from './TextareaField';
export { default as DateField } from './DateField';
export { default as ToggleField } from './ToggleField';
export { default as PhoneArray } from './PhoneArray';
export { default as EmailArray } from './EmailArray';

export const validation = validations;

export const filterErrors = (field, errors) => {
  return Object.keys(errors).filter((key) => {
    return key.startsWith(field);
  }).map((key) => {
    return key.substring(field.length);
  }).reduce((obj, key) => {
    return {
      ...obj,
      [key]: errors[`${field}${key}`],
    };
  }, {});
};

export default class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: props.values,
      errors: {},
      touched: {},
    };

    bindMethods(this, ['onChange', 'getHandler', 'setErrors']);
  }

  onChange(field, value, touchedField) {
    console.log('state ', this.state);
    this.setState((state) => {
      const values = {
        ...state.values,
        [field]: value,
      };
      const touched = {
        ...state.touched,
        [`${field}${touchedField || ''}`]: true,
      };
      const { validate } = this.props;
      return {
        values,
        touched,
        errors: validate ? validate(touched, values) : {},
      };
    });
  }

  getHandler(field) {
    return (e) => {
      this.onChange(field, e.target.value);
    };
  }

  setErrors(errors) {
    this.setState((state) => {
      return {
        errors: {
          ...state.errors,
          ...errors,
        },
      };
    });
  }

  render() {
    const { onChange, getHandler, state, setErrors } = this;
    const { children, noHtmlForm } = this.props;
    const { values, errors, touched } = state;
    const props = {
      values,
      getHandler,
      onChange,
      errors,
      touched,
      setErrors,
      hasErrors: !!Object.keys(errors).length,
    };
    if (noHtmlForm) {
      return children(props);
    }
    return (
      <form>
        {children(props)}
      </form>
    );
  }
}

Form.propTypes = {
  values: PropTypes.shape(),
  children: PropTypes.func.isRequired,
  noHtmlForm: PropTypes.bool,
  validate: PropTypes.func,
};

Form.defaultProps = {
  values: {},
  noHtmlForm: false,
  validate: null,
};
